import { render, staticRenderFns } from "./AppLanding.vue?vue&type=template&id=19178946&"
import script from "./AppLanding.vue?vue&type=script&lang=js&"
export * from "./AppLanding.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/appstore-landing2.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports